export const CONTENT_MASK_SHOW = Symbol('CONTENT_MASK_SHOW');
export const CONTENT_MASK_HIDE = Symbol('CONTENT_MASK_HIDE');

export const contentMaskShowAction = () => ({
  type: CONTENT_MASK_SHOW,
});

export const contentMaskHideAction = () => ({
  type: CONTENT_MASK_HIDE,
});
